/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, since: NonNullable<unknown> }} Motor_Too_SlowInputs */



/**
* | since | output |
* | --- | --- |
* | "false" | "The engine does not run fast enough" |
* | "true" | "The engine does not run fast enough since {date}" |
* | * | "The engine does not run fast enough" |
*
* @param {Motor_Too_SlowInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const motor_too_slow = /** @type {((inputs: Motor_Too_SlowInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Motor_Too_SlowInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.since === "false") return /** @type {LocalizedString} */ (`The engine does not run fast enough`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`The engine does not run fast enough since ${i?.date}`);
		return /** @type {LocalizedString} */ (`The engine does not run fast enough`)
	}
	{
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Le moteur ne tourne pas assez vite`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Le moteur ne tourne pas assez vite depuis le ${i?.date}`);
		return /** @type {LocalizedString} */ (`Le moteur ne tourne pas assez vite`)
	}
});